export const appsConfig = {
  hub: {
    key: 'hub',
    namespace: 'hub',
    label: 'Financial Tools',
    color: 'blue',
    description: 'Survey and health check reports',
  },
  investment: {
    key: 'investment',
    namespace: 'investment',
    label: 'Investment',
    color: '#ffbf00',
    description:
      'Core investment system: manage investors, orders on Stag Invest app',
  },
  admin: {
    key: 'admin',
    namespace: 'admin',
    label: 'Admin',
    color: 'red',
    description: 'Stag platform system ops, for admins only',
  },
  nhsv: {
    key: 'nhsv',
    namespace: 'nhsv',
    label: 'NHSV',
    color: '#1677ff',
    description:
      'NH Securities Vietnam — accounts, orders, and webhooks integration',
  },
  wealth: {
    key: 'wealth',
    namespace: 'wealth',
    label: 'Private Wealth',
    color: '#7c3aed',
    description:
      'Private Wealth management — NAV tracking, fee calculation, customer programs',
  },
  accounting: {
    key: 'accounting',
    namespace: 'accounting',
    label: 'Accounting',
    color: '#13c2c2',
    description: 'Reconciliation and accounting reports across the platform',
  },
  futureflex: {
    key: 'futureflex',
    namespace: 'futureflex',
    label: 'FutureFlex',
    color: '#52c41a',
    description:
      'FutureFlex B2B employee benefit programs — companies, employees, program orders',
  },
  agent: {
    key: 'agent',
    namespace: 'agent',
    label: 'Stag Agent',
    color: '#d97757',
    description:
      'AI agent for ops — look up platform data and manage investment themes in chat',
  },
};
